import store from '@/store';

export default {
  mounted(el, binding) {
    const { value } = binding;

    let userPermissions = store.getters && store.getters.userPermissions;
    userPermissions = userPermissions.map(permission => permission.name);

    if (value && value instanceof Array && value.length > 0) {
      const requiredPermissions = value;
      const hasPermission = userPermissions.some(permission => {
        return requiredPermissions.includes(permission);
      });

      if (!hasPermission) {
        el.parentNode && el.parentNode.removeChild(el);
      }
    } else {
      throw new Error(`Permissions are required! Example: v-permission="['manage user','manage role permission']"`);
    }
  },
  updated(el, binding) {
    const { value } = binding;
    let userPermissions = store.getters && store.getters.userPermissions;
    userPermissions = userPermissions.map(permission => permission.name);

    if (value && value instanceof Array && value.length > 0) {
      const requiredPermissions = value;
      const hasPermission = userPermissions.some(permission => {
        return requiredPermissions.includes(permission);
      });

      if (!hasPermission && el.parentNode) {
        el.parentNode.removeChild(el);
      }
    }
  }
};
